/* eslint-disable @typescript-eslint/no-explicit-any*/
import React from 'react';
import _ from 'lodash';
import { TextField } from '@material-ui/core';
import { MuiAutoComplete } from 'shared/components/MuiAutoComplete';

export interface IAutoCompleteOption {
    value: any;
    title: string;
    code?: any;
}
export interface IFormikInputProps {
    id?: string;
    name?: string;
    options?: Array<any>;
    label?: string;
    variant?: 'standard' | 'filled' | 'outlined';
    getOptionLabel?: (option: any) => string;
    onChange?: (value: any) => void;
    renderInputChange?: (event, value) => void;
    getOptionSelected?: (option, value) => boolean;
    defaultValue?: Array<IAutoCompleteOption>;
    multiple?: boolean;
    optionWithText?: boolean;
}

const FormikAutoComplete = ({
    field: { ...fields },
    form: { touched, errors, ...others },
    ...props
}): React.ReactNode => {
    const {
        id,
        options = [],
        label,
        variant,
        getOptionLabel,
        onChange,
        renderInputChange,
        defaultValue,
        multiple,
        optionWithText,
        ...rest
    }: IFormikInputProps = props;
    const singleFieldError = Boolean(
        (_.get(touched, fields.name) || !!!others.values[fields.name]) && _.get(errors, fields.name),
    );
    const multipleFieldError = Boolean(
        (_.get(touched, fields.name) || others.values[fields.name]?.length === 0) && _.get(errors, fields.name),
    );

    const textBoxField = (params, error) => (
        <TextField
            {...params}
            name={fields.name}
            label={label}
            title={label}
            variant={variant}
            error={error}
            onChange={renderInputChange}
            helperText={error && errors[fields.name]}
        />
    );

    return optionWithText ? (
        <MuiAutoComplete
            {...fields}
            {...rest}
            className="auto-complete"
            id={id}
            freeSolo
            options={options}
            onInputChange={(event, newValue) => {
                onChange && onChange(newValue);
            }}
            renderInput={(params) => textBoxField(params, singleFieldError)}
        />
    ) : !multiple ? (
        <MuiAutoComplete
            {...fields}
            {...rest}
            className="auto-complete"
            id={id}
            options={options}
            getOptionLabel={getOptionLabel}
            defaultValue={defaultValue}
            onChange={(event, newValue) => {
                onChange && onChange(newValue);
            }}
            renderInput={(params) => textBoxField(params, singleFieldError)}
        />
    ) : (
        <MuiAutoComplete
            {...fields}
            {...rest}
            multiple
            options={options}
            limitTags={4}
            getOptionLabel={getOptionLabel}
            defaultValue={defaultValue}
            className="auto-complete"
            value={
                fields?.value
                    ? options?.filter((option) => fields.value?.find((singleValue) => option?.value === singleValue))
                    : []
            }
            onChange={(event, newValue) => {
                onChange && onChange(newValue as IAutoCompleteOption[]);
            }}
            getOptionSelected={(option: IAutoCompleteOption, values: IAutoCompleteOption) => {
                return option.value === values.value;
            }}
            renderInput={(params) => textBoxField(params, multipleFieldError)}
        />
    );
};
export default FormikAutoComplete;
